import { warrantyProcess } from './warranty-process-en.i18n';

export const en = {
  warrantyProcess
};